import { AppAreaConfig } from '@/funnels/@types'
import pilatesFemale from './activity-female-pilates'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-senior-pilates',
	options: {
		userFlags: ['hasAccessToPilatesVideos'],
		userTags: ['pilates'],
	},
	landing: {
		ids: ['loader-pilates-f', 'age-senior-pilates-f'],
		route: {
			path: '/senior-pilates-f',
			name: 'female-senior-pilates-funnel',
		},
	},
	funnel: {
		id: 'ob-female-senior-pilates',
		route: {
			path: '/senior-pilates-f/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-senior-pilates',
		},
		slug: 'activity-female-senior-pilates',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: pilatesFemale,
				page: 'main-goal',
			},
		},
	},
}

export default appAreaConfig
